
import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    // Obtenemos el token actual
    const token = authService.token();
    if (token) {
        // Clonamos la petición y añadimos el header Authorization
        const authReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
        return next(authReq);
    }
    return next(req);
}